export const HEADER_HEIGHT = 64;

export const DEFAULT_FONT = 'TT Hoves';
export const FONT_TYPE = {
  LIGHT: `${DEFAULT_FONT} Light`,
  MEDIUM: `${DEFAULT_FONT} Medium`,
  DEMIBOLD: `${DEFAULT_FONT} Demibold`,
};

export const FONT_WEIGHT = {
  DEFAULT: 300,
  BOLD: 500,
};

export const FONT_COLOR = '#454545';
export const PRIMARY_COLOR = [
  '#00BA8D', // 0
  '#33C8A4', // 1
  '#66D6BB', // 2
  '#99E3D1', // 3
  '#CCF1E8', // 4
  '#F2FBF9', // 5
  '#008768', // 6
  '#00664F', // 7
  '#353A8C', // 8
];

export const SECONDARY_COLOR = [
  '#4F5453', // 0
  '#727675', // 1
  '#959898', // 2
  '#B9BBBA', // 3
  '#DCDDDD', // 4
  '#F5F5F5', // 5
];

export const BREAKPOINTS = {
  LARGE: 1200,
  MEDIUM: 900,
  SMALL: 600,
};

export const Z_INDEX = {
  ERROR: 9999,
  TOAST: 9989,
  LOADER: 9979,
  MODAL: 9969,
  SPLASH: 9959,
  HEADER: 9949,
  DRAWER: 9939,
  DROPDOWN: 9929,
};
